import React from 'react';
import PropTypes from 'prop-types';
import BadgeText from './_badge-text/component';
import BadgeImage from './_badge-image/_component';
import BadgePrice from './_badge-price/component';

import './styles/styles.scss';
import { PRICE_NOTATION_LOCALE } from '../../config';

const transMap = {
  text: BadgeText,
  image: BadgeImage,
  price: BadgePrice,
};

const Badge = (props) => {
  const { variant, type, value, oldValue, badgePriceInput } = props;

  const priceOrTxt = (valWithDotOrComma) => {
    if (!valWithDotOrComma) return null;

    if (typeof valWithDotOrComma !== 'string') return valWithDotOrComma;

    return PRICE_NOTATION_LOCALE === 'en-GB'
      ? valWithDotOrComma.replace(',', '.')
      : valWithDotOrComma.replace('.', ',');
  };

  const badgeVariant = transMap[variant || type];
  if (!badgeVariant) return null;

  const valueProps = {
    value: priceOrTxt(value),
    oldValue: priceOrTxt(oldValue),
    badgePriceInput: priceOrTxt(badgePriceInput),
  };

  const BadgeVariant = badgeVariant;

  return <BadgeVariant {...props} {...valueProps} />;
};

Badge.propTypes = {
  variant: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.any,
  oldValue: PropTypes.any,
  badgePriceInput: PropTypes.any,
};

export default Badge;
